import type { QueryClient } from '@tanstack/vue-query'
import type { ID } from '#shared/index'
import type { Message } from '../model/message'
import type { MessagesQueryData } from '../model/messages-query-data'
import { getFreshMessagesQueryKey } from './fresh-messages-query'
import { getMessagesQueryKeyPrefixByChat } from './messages-query'

type MessageUpdater = (message: Message) => Message

export function updateMessagesByChatId(queryClient: QueryClient, chatId: ID, updateFn: MessageUpdater) {
  queryClient.setQueryData(getFreshMessagesQueryKey(chatId), (queryData: Message[] | undefined) => {
    if (!queryData) return

    return queryData.map(existingMessage => updateFn(existingMessage))
  })

  queryClient.setQueriesData(
    { queryKey: getMessagesQueryKeyPrefixByChat(chatId) },
    (queryData: MessagesQueryData | undefined) => {
      if (!queryData) return

      const newPages = queryData.pages.map(page => ({
        ...page,
        data: page.data.map(existingMessage => updateFn(existingMessage)),
      }))

      return {
        ...queryData,
        pages: newPages,
      }
    }
  )
}
